import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { emptyFunction } from '@/utils/emptyFunction.util.ts';

export type ViewWrapperNewProps<MODEL extends object> = {
  contextObject: MODEL;
  setContextObject: Dispatch<SetStateAction<MODEL>>;
};

export const ViewWrapperNewDefaultValues: ViewWrapperNewProps<object> = {
  contextObject: {},
  setContextObject: emptyFunction,
};

export const ViewWrapperNewContext = createContext<ViewWrapperNewProps<object>>(
  ViewWrapperNewDefaultValues,
);

export const useViewWrapperNewContext = <MODEL extends object>(): ViewWrapperNewProps<MODEL> => {
  // @ts-expect-error: no worries
  return useContext<ViewWrapperNewProps<MODEL>>(ViewWrapperNewContext);
};
